<script setup lang="ts">

import { FiltersBar } from '@shared/ui/filters'
import { AppMultiSelect, AppSelect } from '@shared/ui/selects'
import { AppInput } from '@shared/ui/inputs'

import { useFiltersUsers } from '../model/filters-users.hook'

defineOptions({
  name: 'FiltersUsers',
})

const {
  refSearch,
  refRoles,
  refTeams,
  refStatus,
  roleOptions,
  statusOptions,
  teamOptions,
  isLoading,
  submitSearch,
} = useFiltersUsers()
</script>

<template>
  <FiltersBar
    class="filters-users"
    :loading="isLoading"
    :clearable="false"
    @click:submit="submitSearch"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        label="Search"
        placeholder="Name or email"
      />

      <AppMultiSelect
        v-model="refRoles"
        :options="roleOptions"
        label="Role"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <AppMultiSelect
        v-model="refTeams"
        :options="teamOptions"
        label="Team"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <AppSelect
        v-model="refStatus"
        :options="statusOptions"
        label="Status"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersUsers.scss" />
